import { Typography } from 'antd'
import { Document } from 'features/files/types'
import * as React from 'react'
import styled from 'styled-components'

import { DocumentListItem } from './DocumentListItem'

const { Text } = Typography

export interface DocumentListProps {
  documents: ReadonlyArray<Document>
  selectedDocumentId?: string | null
  onDocumentSelect?: (documentId: string) => void
  onDocumentPreview?: (documentId: string) => void
  className?: string
}

const Container = styled.div`
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 32px 0;
`

export const DocumentList: React.FC<DocumentListProps> = ({
  documents,
  selectedDocumentId,
  onDocumentSelect,
  onDocumentPreview,
  className,
}) => {
  if (documents.length === 0) {
    return (
      <Container className={className}>
        <Text
          strong
          style={{ fontSize: 16, marginBottom: 12, display: 'block' }}>
          Documents
        </Text>
        <EmptyState>
          <Text type='secondary'>No documents found</Text>
        </EmptyState>
      </Container>
    )
  }

  return (
    <Container className={className}>
      <Text strong style={{ fontSize: 16, marginBottom: 12, display: 'block' }}>
        Documents
      </Text>
      <div>
        {documents.map((document) => (
          <DocumentListItem
            key={document.entryId}
            document={document}
            selected={document.entryId === selectedDocumentId}
            onSelect={onDocumentSelect || (() => {})}
            onPreview={onDocumentPreview}
          />
        ))}
      </div>
    </Container>
  )
}
